import * as movieClipScript from '@ps/bridge/qc/scripts/movie-clip'
import actions from './actions'
import { getInitState } from './state'

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    updateData(state, { data }) {
      state.data = data
    },
    updateActionName(state, { actionName }) {
      state.defActionName = actionName
    },
    updatePlayTime(state, { playTime }) {
      state.playTime = playTime
    },
    updateAutoPlay(state, { autoPlay }) {
      state.autoPlay = autoPlay
    },
    updateKeepLastFrame(state, { keepLastFrame }) {
      state.keepLastFrame = keepLastFrame
    },
    updateAutoDestory(state, { autoDestory }) {
      state.autoDestory = autoDestory
    },
    updateInterval(state, { interval }) {
      state.interval = interval
    },
    updatePingPong(state, { pingpong }) {
      state.pingpong = pingpong
    },
    updatePlay(state, { play }) {
      state.defPlay = play
    },
  },

  actions: {
    getCurrentSequenceFrame({ rootState, state }) {
      const gameState = rootState.workspace.game
      const mv = movieClipScript.getScript(gameState.activeNode)
      if (typeof mv === 'undefined') {
        return
      }
      movieClipScript.fixMovieClipData(gameState.activeNode)
      state.data = mv.data
      state.defActionName = mv.defActionName
      state.playTime = mv.playTime
      state.interval = mv.interval
      state.autoPlay = mv.autoPlay
      state.keepLastFrame = mv.keepLastFrame
      state.autoDestory = mv.autoDestory
      state.pingpong = mv.pingpong
      state.defPlay = mv.defPlay
    },

    /**
     * 用于预览序列帧某个action
     * @param node 节点
     * @param play 是否需要播放
     */
    playAction({ state, rootState }, node) {
      const gameState = rootState.workspace.game
      const opNode = node || gameState.activeNode
      const mv = movieClipScript.getScript(opNode)
      mv.defActionName = state.defActionName
      mv.playTime = state.playTime
      mv.autoPlay = state.autoPlay
      mv.keepLastFrame = state.keepLastFrame
      if (Number(state.interval) === 0) {
        mv.interval = 10
      } else {
        mv.interval = Number(state.interval)
      }
      mv.autoDestory = state.autoDestory
      mv.pingpong = state.pingpong
      mv.defPlay = state.defPlay
      mv.data = state.data
      mv.initData()
      mv.gotoAndPlay(state.defActionName, mv.playTime, null, null, mv.pingpong)
    },

    // 暂停序列帧
    stopAction({ state, rootState }, node) {
      const gameState = rootState.workspace.game
      const opNode = node || gameState.activeNode
      const mv = movieClipScript.getScript(opNode)
      mv.stop()
    },

    // 播放当前序列帧节点
    playSequenceFrame({ rootState }, node) {
      const mv = movieClipScript.getScript(node)
      if (mv.autoPlay) {
        mv.gotoAndPlay(mv.defActionName, mv.playTime, null, null, mv.pingpong)
      } else {
        mv.gotoAndStop(mv.defActionName, 1)
      }
    },

    stopAtFirstFrame({ state, rootState }, node) {
      const gameState = rootState.workspace.game
      const opNode = node || gameState.activeNode
      const mv = movieClipScript.getScript(opNode)
      mv.gotoAndStop(mv.defActionName, 1)
    },

    ...actions,
  },
}
